/* ==========================================================================
   CalendarRxjs > Client > Config
   ========================================================================== */

/* Import modules */
const { css } = require('../../../input-rxjs/client/js/config')();

/* Config */
const config = {
    component: 'CalendarRxjs',
    init: true,
    start: true,
    events: true,
    icon: {
        calendar: 'calendar',
        cancel: 'cancel'
    },
    type: {
        clear: 'calendar-rxjs-clear'
    },
    css: {
        alternative: css.alternative,
        valid: css.valid,
        error: css.error,
        active: css.active,
        hidden: css.hidden,
        disabled: css.disabled,
        withBorder: css.withBorder,
        clear: 'calendar-rxjs__clear'
    }
};

module.exports = () => config;
